'use client';

import { useLocale } from 'next-intl';
import { type PropsWithChildren } from 'react';

import { useLockedResourcePrompt } from '@module/mdrt-org/shared/block-components/learn-carousel-block/components/learn-content-carousel/components/locked-resource-prompt/locked-resource-prompt';
import { Link } from '@module/mdrt-org/shared/i18n/i18n-navigation-link';
import { getRelativePathWithoutLocale } from '@module/mdrt-org/shared/utils/helpers/get-relative-path-without-locale';

export const LockedContentModalTriggerWrapper = ({
  children,
  className,
  cmsContent,
  'data-testid': dataTestId,
  resourceUrl,
}: PropsWithChildren<{
  className?: string;
  cmsContent: {
    cancelLabel: string;
    lockedResourceModalHeading: string;
    lockedResourceModalSubheading: string;
    loginLinkLabel: string;
  };
  ['data-testid']?: string;
  resourceUrl: string;
}>) => {
  const locale = useLocale();
  const { onResourceClick, renderLockedResourcePrompt, shouldLockedResourcePromptBeShown } =
    useLockedResourcePrompt({
      cmsContent,
      isResourceLocked: true,
      resourceUrl,
    });

  const sharedProps = {
    className,
    'data-testid': dataTestId,
  };

  const formattedUrl = getRelativePathWithoutLocale(resourceUrl, locale);

  return (
    <>
      {renderLockedResourcePrompt()}
      {shouldLockedResourcePromptBeShown ? (
        <button {...sharedProps} onClick={onResourceClick} type="button">
          {children}
        </button>
      ) : (
        <Link {...sharedProps} href={formattedUrl} scroll>
          {children}
        </Link>
      )}
    </>
  );
};
